module.exports = __webpack_public_path__ + "img/ampliados.53802773.svg";